import React from 'react';
import { useSelector } from 'react-redux';
import { Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';

import Loader from 'components/Loader/Loader';

import history from 'routes/history';
import Routes from 'routes/routes';

import texts from 'assets/locale/texts';

function App({ loading }) {
    const language = useSelector((state) => state.language);

    function flattenMessages(nestedMessages: Object, prefix = '') {
        return Object.keys(nestedMessages).reduce((messages, key) => {
          const msg = messages;
          const value = nestedMessages[key];
          const prefixedKey = prefix ? `${prefix}.${key}` : key;
          if (typeof value === 'string') {
            msg[prefixedKey] = value;
          } else {
            Object.assign(msg, flattenMessages(value, prefixedKey));
          }
          return msg;
        }, {});
      }

    return (
        <IntlProvider locale={language.currentLanguage} messages={flattenMessages(texts[language.currentLanguage])}>
            {loading ? <Loader /> : null}
            <Router history={history}>{<Routes language={language.currentLanguage} />}</Router>
        </IntlProvider>
    );
}

export default App;
